module.exports = __webpack_public_path__ + "img/环保DISCO.932b9b8d.png";